module.exports = __webpack_public_path__ + "static/media/Muted_Balance.037c74c8.jpg";